import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { useLazyRounds } from "../hooks";

import { EmptyList, Loading, Header } from "../../../components";
import { parseSearchParams } from "../../../helpers/clean-object";

export const Rounds: React.FC = () => {
  const navigate = useNavigate();
  const [search, { data, error, loading }] = useLazyRounds();
  const [searchParams] = useSearchParams();
  useEffect(() => {
    search({
      fetchPolicy: "network-only",
      variables: {
        where: parseSearchParams(searchParams),
      },
    });
  }, [searchParams]);

  const renderList = () => {
    if (loading) return <Loading />;
    if (data?.rounds?.results?.length === 0) {
      return <EmptyList text="Aucune tournée" />;
    }

    return (
      <table className="table-auto w-full">
        <thead>
          <tr className="text-xs text-gray-500 text-left">
            <th className="padding-table font-medium text-left">Site</th>
            <th className="padding-table font-medium text-center">
              Sentinelle
            </th>
            <th className="padding-table font-medium text-center">Heure</th>
          </tr>
        </thead>
        <tbody>
          {data?.rounds?.results?.map((round, index) => (
            <tr
              onClick={() => navigate(`/round/${round.id}`)}
              key={`round-${round.id}`}
              className={`text-xs cursor-pointer ${
                index % 2 ? "" : "bg-gray-50"
              } `}
            >
              <td className="padding-table text-left">
                {round?.site?.url ?? "-"}
              </td>
              <td className="padding-table text-center">
                {round.sentinel?.ip}
              </td>
              <td className="padding-table text-center">{round.hour}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <>
      <Header title="Round" subtitle="Liste des rounds" />

      <div className="main-container">
        <button className="btn mb-2" onClick={() => navigate("/round/create")}>
          Nouvelle Tournée
        </button>
        <div className="p-4 mb-6 bg-white shadow rounded overflow-x-auto">
          {renderList()}
        </div>
      </div>
    </>
  );
};
